import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { MessagingChannelType } from 'cio/utils/setup-guide/messaging-channels';
import AnalyticsService from 'cio/services/analytics';
import SetupGuide from 'cio/models/setup-guide';

type MessagingChannelDetails = {
  type: MessagingChannelType;
  title: string;
  description: string;
  route: string;
};

const MESSAGING_CHANNELS: MessagingChannelDetails[] = [
  {
    type: MessagingChannelType.Email,
    title: 'Email',
    description: 'Send all of your emails, from onboarding campaigns to transactional messages.',
    route: 'setup-guide.channels.email',
  },
  {
    type: MessagingChannelType.InApp,
    title: 'In-App',
    description: 'Create on-brand experiences that embed seamlessly into your website and mobile app.',
    route: 'setup-guide.channels.in_app',
  },
  {
    type: MessagingChannelType.Push,
    title: 'Push',
    description: 'Engage with your app users to drive app revenue and improve retention.',
    route: 'setup-guide.channels.push',
  },
  {
    type: MessagingChannelType.Twilio,
    title: 'Twilio',
    description: 'Send important reminders about deliveries, appointments, and more via text message.',
    route: 'setup-guide.channels.twilio',
  },
  {
    type: MessagingChannelType.Slack,
    title: 'Slack',
    description: 'Send customer activity directly into Slack to help your teams work better together.',
    route: 'setup-guide.channels.slack',
  },
  {
    type: MessagingChannelType.Webhook,
    title: 'Webhooks',
    description: 'Fuel workflow automation by connecting to other services your business uses.',
    route: 'setup-guide.channels.webhooks',
  },
];

export default class SetupGuidesChannelsIndexController extends Controller {
  @service analytics!: AnalyticsService;

  model!: SetupGuide;
  channels = MESSAGING_CHANNELS;

  get firstIncompleteChannel() {
    let { messagingChannels } = this.model;
    return messagingChannels.find((channel) => !channel.completedAt) ?? messagingChannels[0];
  }

  @action
  selectChannel(type: MessagingChannelType) {
    return this.model.addChannel(type);
  }

  @action
  deselectChannel(type: MessagingChannelType) {
    this.model.set(
      'messagingChannels',
      this.model.messagingChannels.filter((channel) => channel.type !== type),
    );
    return this.model.save();
  }

  @action
  onClickSetupChannels() {
    this.analytics.track('onboarding', 'setup_channels_clicked', { types: this.model.messagingChannelTypes });
  }
}
